<div class="pt-1 ps-1 w-md-85 w-100">
  <textarea (blur)="saveNote(); isEditing = false" (focus)="isEditing = true"
            (keydown.enter)="$event.target.blur()"
            [(ngModel)]="offerNote" [placeholder]="'offer-notes.placeholder' | translate"
            cdkAutosizeMaxRows="5" cdkAutosizeMinRows="1" cdkTextareaAutosize class="offer-notes" id="offer-notes">
  </textarea>
</div>
@if (isEditing) {
  <label class="offer-notes-label w-85 d-none d-md-block mt-1" for="offer-notes">
    {{ 'offer-notes.label' | translate }}</label>
} @else {
  <label class="offer-notes-label w-85 d-none d-md-block mt-1 placeholder-label" for="offer-notes"></label>
}

